import { AppFormData } from '../../models/FormState'

export const SAVE_FORM_DATA = 'form//SAVE_FORM_DATA'
export const SET_VALID_SECTIONS = 'form//SET_VALID_SECTIONS'

interface SaveFormDataAction {
  type: typeof SAVE_FORM_DATA
  payload: AppFormData
}

interface SetValidSections {
  type: typeof SET_VALID_SECTIONS
  payload: boolean[]
}

export type FormActions = SaveFormDataAction | SetValidSections
